import { Button, ButtonProps, SxProps, Theme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import BackIcon from '@mui/icons-material/ArrowBackIos';

interface BackButtonProps {
  labelKey?: string;
  onBackPressed?: () => void;
  size?: ButtonProps['size'];
  sx?: SxProps<Theme>;
}

export const BackButton = (props: BackButtonProps) => {
  const navigate = useNavigate();

  const defaultBackAction = () => navigate(-1);
  return (
    <Button
      onClick={props.onBackPressed ?? defaultBackAction}
      variant='text'
      size={props.size}
      startIcon={<BackIcon />}
      sx={{ '&.MuiButton-root': { px: 3, py: 2 }, flexShrink: 0, ...props.sx }}
    >
      <FormattedMessage id={props.labelKey ?? 'actions.back'} />
    </Button>
  );
};
